// https://github.com/coast-app/core-api/blob/master/packages/core-models/src/workflow-template/components/InputComponentTypes.ts
export const INPUT_COMPONENT_TYPES = [
  'ADDRESS',
  'AUDIT_CHECKBOX',
  'AUDIT_TAG',
  'AUDIT_TEXT',
  'DATE',
  'EMAIL',
  'ENTITY_BATCH',
  'FILE',
  'GEOLOCATION',
  'NUMBER',
  'PERSON',
  'RELATED_CARD',
  'RELATED_CARD_LOOKUP',
  'SCHEDULED_AUTOMATION',
  'SIGNATURE',
  'SUBFORM',
  'TAG',
  'TEXT',
  'TIME_TRACKER',
  'TODO',
  'URL',
] as const;

export type InputComponentType = (typeof INPUT_COMPONENT_TYPES)[number];

export const INPUT_COMPONENT_TYPE_VALUES: readonly string[] = INPUT_COMPONENT_TYPES;

export type InputComponent =
  | MBAPI.WorkflowTemplate_components_AddressComponent
  | MBAPI.WorkflowTemplate_components_AuditCheckboxComponent
  | MBAPI.WorkflowTemplate_components_AuditTagComponent
  | MBAPI.WorkflowTemplate_components_AuditTextComponent
  | MBAPI.WorkflowTemplate_components_DateComponent
  | MBAPI.WorkflowTemplate_components_EmailComponent
  | MBAPI.WorkflowTemplate_components_EntityBatchComponent
  | MBAPI.WorkflowTemplate_components_FileComponent
  | MBAPI.WorkflowTemplate_components_GeolocationComponent
  | MBAPI.WorkflowTemplate_components_NumberComponent
  | MBAPI.WorkflowTemplate_components_PersonComponent
  | MBAPI.WorkflowTemplate_components_RelatedCardComponent
  | MBAPI.WorkflowTemplate_components_RelatedCardLookupComponent
  | MBAPI.WorkflowTemplate_components_ScheduledAutomationComponent
  | MBAPI.WorkflowTemplate_components_SignatureComponent
  | MBAPI.WorkflowTemplate_components_SubformComponent
  | MBAPI.WorkflowTemplate_components_TagComponent
  | MBAPI.WorkflowTemplate_components_TextComponent
  | MBAPI.WorkflowTemplate_components_TimeTrackerComponent
  | MBAPI.WorkflowTemplate_components_TodoComponent
  | MBAPI.WorkflowTemplate_components_UrlComponent;
